import { render, staticRenderFns } from "./FormGraphicalPDFSignatureField.vue?vue&type=template&id=06821edb&scoped=true&"
import script from "./FormGraphicalPDFSignatureField.vue?vue&type=script&lang=ts&"
export * from "./FormGraphicalPDFSignatureField.vue?vue&type=script&lang=ts&"
import style0 from "./FormGraphicalPDFSignatureField.vue?vue&type=style&index=0&id=06821edb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06821edb",
  null
  
)

export default component.exports